// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledCurrency from '../../../../shared/components/labeled-currency';
import LabeledString from '../../../../shared/components/labeled-string';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import {Link} from 'react-router';
import {buildDate} from '../../../../shared/services/build-date';

const LaborRateChangesResult = props =>
    <section className='labor-rate-change-result'>
        <header>
            <section className='dealer-name'>
                {props.laborRateChange.responsibleAccount.name}
            </section>
        </header>
        <main>
            <div className='labor-rate-change-details'>
                {
                    props.laborRateChange.rates.map(rate =>
                        <LabeledCurrency
                            data={rate.requestedRate}
                            key={rate.description}
                            label={rate.description}
                            shouldTranslate={false}
                        />
                    )
                }
                <LabeledCurrency
                    data={props.laborRateChange.averageTechPayRate}
                    label='AVERAGE_TECH_PAY_RATE'
                />
            </div>
            <div className='effective-date'>
                <LabeledString
                    data={buildDate(props.laborRateChange.effectiveDate)}
                    label='EFFECTIVE_DATE'
                />
                <LabeledString
                    data={props.laborRateChange.requestedBy.buildUserName() || <FormattedMessage id='NO_USER_FOUND'/>}
                    label='REQUESTED_BY'
                />
            </div>
        </main>
        <footer>
            <Link
                className='primary'
                to={`/tcsm/wip/labor-rates/${props.laborRateChange.requestId}`}
            >
                <FormattedMessage id='VIEW_DETAILS'/>
            </Link>
        </footer>
    </section>;

LaborRateChangesResult.displayName = 'LaborRateChangesResult';
LaborRateChangesResult.propTypes = {
    laborRateChange: PropTypes.instanceOf(LaborRate).isRequired
};

export default LaborRateChangesResult;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/labor-rate-changes/labor-rate-changes-result.js